<div class="form-group">
  <label [for]="fieldId" class="label text-muted font-weight-bolder"> {{label}}
    <span *ngIf="required" class="text-danger">*</span> </label>
  <textarea [formControl]="control" [id]="fieldId" [attr.cols]="cols" [attr.rows]="rows"
    class="form-control form-control-sm"></textarea>
  <app-form-validation [validationErrors]="validationErrors"></app-form-validation>
</div>
